/**
 * MP3-only mode is an explicit fallback for running the local participant flow
 * without provider credentials or backend services. Normal web and mobile
 * builds keep Spotify, Apple Music, and YouTube enabled.
 */
export const isMp3OnlyMode =
  process.env.NEXT_PUBLIC_MP3_ONLY === "true";
